export default __webpack_public_path__ + "static/logo-tv-plus-969e378101277b40adc181c083e687f2.png";